import React, { useEffect, useRef, useState } from "react";
import ModalContainer from "../../common/ModalContainer";
import CommonTextareaInput from "../../common/inputs/CommonTextareaInput";
import InvoicePDFSection from "../../../sections/invoice/staticPdf/InvoicePDFSection";
import usePDF from "../../../hooks/flight/usePDF";
import { CreateServiceModal } from "./CreateServiceModal";
import CommonDateSelectorInput from "../../common/inputs/CommonDateSelectorInput";
import { useSelector } from "react-redux";
import useInvoiceApi from "../../../hooks/useInvoiceApi";
import CreateInvoiceServicesSection from "./CreateInvoiceServicesSection";
import CreateInvoiceTaxSection from "./CreateInvoiceTaxSection";
import CreateInvoiceServiceFeeSection from "./CreateInvoiceServiceFeeSection";
import moment from "moment";
import { ConfirmInvoiceModal } from "./ConfirmInvoiceModal";
import CreateInvoiceNumberSection from "./CreateInvoiceNumberSection";
import CreateInvoiceCustomerSection from "./CreateInvoiceCustomerSection";
import { CreateCustomerModal } from "./CreateCustomerModal";
import { configurations } from "../../../configurations";

const initData = {
  invoiceNo: "",
  invalidInvoice: false,
  customer: "",
  agentCustomer: "",
  oneTimeCustomerName: "",
  oneTimeCustomerAddress: "",
  notes: "",
  companyName: "",
  email: "",
  companyAddress: "",
  amount: "",
  service: "",
  date: "",
  orderType: "",
  services: [],
  flightBookings: [],
  hotelBookings: [],
  packageBookings: [],
  insuranceBooking: [],
  newCustomer: {
    opened: false,
    name: "",
    email: "",
    address: "",
  },
  newService: {
    opened: false,
    service: "",
  },
  tax: {
    value: "",
    taxMethod: "Percentage",
  },
  serviceFee: {
    value: "",
    feeMethod: "Percentage",
  },
};

const pdfData = {
  companyName: "Company name LLC",
  companyLogo:
    "https://plus.unsplash.com/premium_photo-1666277012916-1c1c7bc88122?w=600",
  invoiceNo: "#000123",
  customerName: "Client Name",
  customerAddress: "Address / Contact Info",
  companyAddress: "Address / Contact Info",
  notes: "Have a great day",
  email: "email@company.com",
  paidOn: "December 7, 2022.",
  paymentDue: "December 7, 2022.",
  services: [
    {
      title: "Flight Reservation",
      passengers: "1",
      price: "₦4,000.00",
      total: "₦4,000.00",
      details: [
        "Lagos - London (Return) ",
        "Nov 12 - 24 Dec - British Airways",
      ],
    },
    {
      title: "Flight Reservation",
      passengers: "1",
      price: "₦4,000.00",
      total: "₦4,000.00",
      details: [
        "Lagos - London (Return) ",
        "Nov 12 - 24 Dec - British Airways",
      ],
    },
    {
      title: "Flight Reservation",
      passengers: "1",
      price: "₦4,000.00",
      total: "₦4,000.00",
      details: [
        "Lagos - London (Return) ",
        "Nov 12 - 24 Dec - British Airways",
      ],
    },
  ],
  total: "₦4,000.00",
  paymentLink: "https://www.paystack.com/intraverse",
};

export const CreateInvoiceModal = ({
  setOpen,
  open,
  order = false,
  orderType,
  detail,
}) => {
  const { services } = useSelector((state) => state.invoice);
  const { getServices } = useInvoiceApi();
  const [serviceModal, setServiceModal] = useState(false);
  const { handlePDFDownload } = usePDF();
  const [sendLoading, setSendLoading] = useState(false);
  const [servicesLoading, setServicesLoading] = useState(false);
  const [data, setData] = useState(initData);
  const [confirmModal, setConfirmModal] = useState(false);
  const [customerModal, setCustomerModal] = useState(false);

  const [customers, setCustomers] = useState([]);
  const pdfRef = useRef();

  const loadServices = async () => {
    if (!open) return;
    if (services?.length) return;
    getServices({
      setLoading: setServicesLoading,
    });
  };

  const loadData = async () => {
    const promises = [loadServices()];
    await Promise.all(promises);
  };

  useEffect(() => {
    loadData();
  }, []);

  const addOrder = () => {
    switch (orderType) {
      case configurations.products.flight.value:
        setData({
          ...data,
          orderType,
          flightBookings: [order],
        });
        break;
      case configurations.products.stay.value:
        setData({
          ...data,
          orderType,
          hotelBookings: [order],
        });
        break;
      case configurations.products.tour.value:
        setData({
          ...data,
          orderType,
          packageBookings: [order],
        });
        break;
      case configurations.products.insurance.value:
        setData({
          ...data,
          orderType,
          insuranceBooking: [order],
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    addOrder();
  }, [order]);

  // const handleExport = async () => {
  //   if (pdfRef?.current) {
  //     let string = pdfRef.current.outerHTML;
  //     setDownloadModal(true);
  //     await handlePDFDownload(string, {
  //       fileName: "Invoice" || "",
  //     }).finally(() => setDownloadModal(false));
  //   }
  // };

  const handleConfirm = async () => {
    setOpen(false);
    setConfirmModal(true);
  };

  const invoiceDisabled = () => {
    if (
      data?.customer &&
      !data?.invalidInvoice &&
      (order ? true : data?.services?.length) &&
      data?.date
    ) {
      return false;
    }
    return true;
  };

  const Footer = () => {
    return (
      <div className="w-full flex flex-col pt-2 bg-white">
        <hr className="border-gray-300 my-3 mb-6" />
        <div className="flex gap-4 items-center">
          <button
            className="flex items-center justify-center text-secondaryflex-1 font-semibold w-44 py-4 rounded-lg text-xs sm:text-lg"
            onClick={() => setOpen(false)}
          >
            <span>Close</span>
          </button>
          <button
            className="bg-primary1 disabled:bg-gray-500 disabled:cursor-not-allowed flex items-center justify-center text-secondaryflex-1 text-white w-full py-4 rounded-lg text-xs sm:text-lg"
            onClick={() => handleConfirm()}
            disabled={invoiceDisabled()}
          >
            {sendLoading ? (
              <div className="buttonLoader"></div>
            ) : (
              <span>Confirm</span>
            )}
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <ConfirmInvoiceModal
        open={confirmModal}
        setOpen={setConfirmModal}
        data={data}
        onClose={() => {
          setOpen(true);
        }}
        customers={customers}
        onDone={() => {
          setData(initData);
        }}
      />
      <div className="z-20">
        <CreateServiceModal open={serviceModal} setOpen={setServiceModal} />
        <CreateCustomerModal open={customerModal} setOpen={setCustomerModal} />
      </div>
      <div className="z-10">
        <ModalContainer
          open={open}
          setOpen={setOpen}
          secondary
          padding="px-4 py-6"
          title={"Request payment"}
          subTitle="Enter details of your invoice"
          // footer={<Footer />}
        >
          <div className="w-full flex flex-col">
            <div className="hidden">
              <div className="" ref={pdfRef}>
                <InvoicePDFSection data={pdfData} />
              </div>
            </div>
            <div className="w-full">
              <div className="relative overflow-x-auto flex flex-col scroll-hide">
                <div className="flex flex-col p-4 w-full rounded-md">
                  <CreateInvoiceNumberSection data={data} setData={setData} />
                  {open ? (
                    <CreateInvoiceCustomerSection
                      data={data}
                      setData={setData}
                      setModal={setCustomerModal}
                      customers={customers}
                      setCustomers={setCustomers}
                    />
                  ) : (
                    <></>
                  )}
                  <CreateInvoiceServicesSection
                    order={order}
                    data={data}
                    setData={setData}
                    services={services}
                    setServiceModal={setServiceModal}
                  />
                  <CreateInvoiceServiceFeeSection
                    data={data}
                    setData={setData}
                  />
                  <CreateInvoiceTaxSection data={data} setData={setData} />

                  <div className="w-full gap-3 flex mt-3">
                    <CommonDateSelectorInput
                      label="Due date"
                      value={data.date}
                      minDate={moment().startOf("day").toDate()}
                      onChange={(val) => setData({ ...data, date: val })}
                    />
                  </div>
                  <div className="w-full gap-3 flex mt-3">
                    <CommonTextareaInput
                      label="Notes"
                      value={data.notes}
                      onChange={(val) => setData({ ...data, notes: val })}
                      placeholder="Additional notes"
                    />
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </ModalContainer>
      </div>
    </>
  );
};

const ClassName = {
  whiteButton: "py-4 px-6 text-xs md:text-lg font-bold w-full max-w-[174px]",
};
